import { FnCmp } from "./clientSorting";
/**
 * Сортировка для случая, когда указана функция извлечения string-значений из строки таблицы.
 * @param getValue
 */
export const strSorter =
  <TRow>(getValue: (row: TRow) => string): FnCmp<TRow> =>
  (aRow: TRow, bRow: TRow): number =>
    getValue(aRow).localeCompare(getValue(bRow));

export type StrConvert = (src: string) => string;
export const noCvt: StrConvert = (src: string) => src;

export const cvtInsensitive: StrConvert = (src: string) => src.toLowerCase();

/**
 * Сортировка для случая, когда указано поле (string) и функция преобразования
 * @param field
 * @param convert по-умолчанию cvtInsensitive, т.к. если с учетом регистра, то сойдет defaultSorter
 */
export const strFieldSorter = <TRow>(
  field: keyof TRow,
  convert: StrConvert = cvtInsensitive,
): FnCmp<TRow> => strSorter((row: TRow) => convert(String(row[field])));

/**
 * Сортировка для случая, когда в колонке используется справочник для преобразования кодов в названия.
 * @param field Либо ключ поля, либо функция. Но в итоге должны получить key для справочника.
 * @param ref Справочник для извлечения по ключу значений, которые будут использованы для сортировки
 * @param convert можно указать cvtInsensitive если нужно сортировать названия из справочника без учета р-ра
 */
export const refSorter = <TRow, RefKey extends number | string | symbol>(
  field: (row: TRow) => RefKey,
  ref: Record<RefKey, string>,
  convert: StrConvert = noCvt,
): FnCmp<TRow> => strSorter((row) => convert(ref[field(row)] ?? ""));
